import React, { useEffect, useState } from 'react';
import './publicRichText.css';
import { Helmet } from 'react-helmet-async';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';
import { FileText } from 'lucide-react';
import { Skeleton } from '../../components/ui/skeleton';
import settingsService from '../../services/settings.service';

function Envios() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [termsPageHtml, setTermsPageHtml] = useState('');

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const s = await settingsService.getPublicSettings();
        if (!cancelled) {
          setTermsPageHtml((s.termsPageHtml || '').trim());
        }
      } catch {
        if (!cancelled) setTermsPageHtml('');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    void load();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!loading && !termsPageHtml) {
    return <Navigate to='/' replace />;
  }

  return (
    <div className='min-h-screen bg-white font-sans text-ink'>
      <Helmet>
        <title>{t('terms.title')}</title>
      </Helmet>

      <div className='mx-auto max-w-3xl px-4 py-10 lg:px-8 lg:py-14'>
        {/* Header */}
        <div className='mb-8 flex items-start gap-3'>
          <div className='flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-zinc-100'>
            <FileText className='h-5 w-5 text-zinc-600' />
          </div>
          <div>
            <h1 className='text-2xl font-bold leading-tight sm:text-3xl'>
              {t('terms.raffleTerms')}
            </h1>
            <p className='mt-1 text-sm text-zinc-500'>
              {t(
                'terms.subtitle',
                'Términos y condiciones que aplican a la participación en nuestros bonos.'
              )}
            </p>
          </div>
        </div>

        {/* Content card */}
        <div className='rounded-2xl border border-zinc-200 bg-white p-6 shadow-sm sm:p-8'>
          {loading ? (
            <div className='space-y-3'>
              <Skeleton className='h-5 w-3/4' />
              <Skeleton className='h-4 w-full' />
              <Skeleton className='h-4 w-5/6' />
              <Skeleton className='h-4 w-4/6' />
              <Skeleton className='mt-6 h-5 w-2/3' />
              <Skeleton className='h-4 w-full' />
              <Skeleton className='h-4 w-3/4' />
            </div>
          ) : (
            <div
              className='public-page-rich-text text-ink'
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(termsPageHtml, { ADD_ATTR: ['class'] }),
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Envios;
